// src/styles/GlobalStyles.js
import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: Arial, sans-serif;
    background-color: #f0f0f0;
    color: #263238;
    overflow-x: hidden;
  }

  @media (min-width: 768px) {
    /* Adjust spacing and font sizes for tablet and desktop */
  }
  
`;


export default GlobalStyles;
